module.exports = __webpack_public_path__ + "img/cod-label.897731e9.svg";